import * as Yup from 'yup';

export const EntradaValidationSchema = Yup.object().shape({
	quantidade: Yup.number()
		.required('Campo obrigatório')
		.min(1, 'Quantidade não deve ser inferior a 1'),
});

export const SaidaValidationSchema = Yup.object().shape({
	tipoSaida: Yup.string().required('Campo obrigatório'),
	dataSaida: Yup.string().required('Campo obrigatório'),
	oficio: Yup.string().nullable().when(['tipoSaida'], {
		is: tipoSaida => tipoSaida === 'oficio',
		then: Yup.string().required('Campo obrigatório'),
	}),
	evento: Yup.string().nullable().when(['tipoSaida'], {
		is: tipoSaida => tipoSaida === 'evento',
		then: Yup.string().required('Campo obrigatório'),
	}),
	status: Yup.string().nullable().when(['tipoSaida'], {
		is: tipoSaida => tipoSaida === 'oficio',
		then: Yup.string().required('Campo obrigatório'),
	}),
	quantidade: Yup.number()
		.required('Campo obrigatório')
		.min(1, 'Quantidade não deve ser inferior a 1'),
	termoRecebimento: Yup.string()
		.required('Campo obrigatório'),

}, [['tipoSaida', 'oficio'], ['tipoSaida', 'evento'], ['tipoSaida', 'status']]);


export const SaidaValidationSchemaEdit = Yup.object().shape({
	tipoSaida: Yup.string().required('Campo obrigatório'),
	dataSaida: Yup.string().required('Campo obrigatório'),
	oficioDestino: Yup.string().nullable().when(['tipoSaida'], {
		is: tipoSaida => tipoSaida === 'oficio',
		then: Yup.string().required('Campo obrigatório'),
	}),
	ocorrenciaDestino: Yup.string().nullable().when(['tipoSaida'], {
		is: tipoSaida => tipoSaida === 'evento',
		then: Yup.string().required('Campo obrigatório'),
	}),
	statusOficio: Yup.string().nullable().when(['tipoSaida'], {
		is: tipoSaida => tipoSaida === 'oficio',
		then: Yup.string().required('Campo obrigatório'),
	}),
	quantidade: Yup.number()
		.required('Campo obrigatório')
		.min(1, 'Quantidade não deve ser inferior a 1'),
	termoRecebimento: Yup.string()
		.required('Campo obrigatório'),

}, [['tipoSaida', 'oficioDestino'], ['tipoSaida', 'ocorrenciaDestino'], ['tipoSaida', 'statusOficio']]);
